import React from 'react';

import '../assets/styles/Theme.scss';
import 'react-toastify/dist/ReactToastify.css';
import Routes from '../routes/Routes';

// For Dark import Theme-Dark.scss
// import './assets/scss/Theme-Dark.scss';

const App = () => {
  return (
    <>
      <Routes></Routes>
    </>
  );
};

export default App;
